const eventFilterCoupon = (filter1, filter2, typeID) => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `${typeID}_servis_pilih_filter_button`,
    eventCategory: `${typeID} servis page`,
    eventAction: `click on pilih`,
    eventLabel: `${typeID} servis page - plp`,
    filter: `${filter1?.isDiskon || 'not available'} - ${filter2?.join(', ') || 'not available'}`,
  });
};
export default eventFilterCoupon;
